/**
 * 배포 시 이 값을 바꾸면 서비스 워커 URL이 바뀌어
 * 모든 클라이언트가 새 캐시를 받게 됩니다.
 */
export const CACHE_BUSTER = "20261010-3";
